import { defineStore } from 'pinia'

export const useSessionsStore = defineStore('sessions', () => {
    function getSessionId() {
        const key = 'tavern_session';
        const itemStr = localStorage.getItem(key);
        if (!itemStr) {
            localStorage.removeItem(key);
        }
    }
    return {
        getSessionId,
    };
})
